import React from 'react';
import { useRouter } from 'next/router';

import app from 'components/app';
import Page from 'components/Page';
import Section from 'components/Page/Section';
import Wrapper from 'components/Page/Wrapper';
import H1 from 'components/typo/Heading/H1';
import { centeredHeader } from 'components/Page/Section/styled/jumbotron';
import ContactForm from 'components/ContactForm';
import { withTranslation } from 'lib/i18n';

import illu from './images/illustration_contact.svg';
import ContactImage from './ContactImage';
import { jumbotron } from './styles';
import { ContactProps } from './types';

const Contact: React.FC<ContactProps> = props => {
  const router = useRouter();
  return (
    <Page title={props.t('contact.title')} footer noPadding>
      <>
        <Section sidbColor>
          <Wrapper css={jumbotron}>
            <>
              <H1 css={centeredHeader}>{props.t('contact.title')}</H1>
              <ContactImage src={illu} />
            </>
          </Wrapper>
        </Section>
        <Section gray topWave>
          <ContactForm
            organizationsDemo={router.query?.organizationsDemo !== undefined}
          />
        </Section>
      </>
    </Page>
  );
};

export default app(withTranslation('pages')(Contact));
